import "./index.scss";
import "./styles/app.scss";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
// import { toastr } from "react-redux-toastr";
// import { registerSW } from "virtual:pwa-register";

// if ("serviceWorker" in navigator) {
//   const updateSW = registerSW({
//     onNeedRefresh() {
//       const toastrConfirmOptions = {
//         onCancel: () => {},
//         cancelText: "Close",
//         okText: "Update Now",
//         onOk: () => updateSW(true),
//       };
//       toastr.confirm("New version available", toastrConfirmOptions);
//     },
//   });
// }

// we are currently on react 17 so disable this eslint warning
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<App />, document.getElementById("root"));

// registerSW({ immediate: true }); // for auto update
